import { render, staticRenderFns } from "./SpfTable.vue?vue&type=template&id=4fbdb51d&scoped=true&"
import script from "./SpfTable.vue?vue&type=script&lang=ts&"
export * from "./SpfTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpfTable.vue?vue&type=style&index=0&id=4fbdb51d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbdb51d",
  null
  
)

export default component.exports